module.exports = ".components-list td {\n  font-size: 0.9em;\n}\n\n.refund-button {\n  width: 32px;\n  height: 31px;\n  padding: inherit;\n  font-size: inherit;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/payment-list/payment-list.component.css
// module id = ./src/app/payment/payment-list/payment-list.component.css
// module chunks = main